import type { FaireProductEntity } from "../../entity_types/product";

export const p_ftn4v8dgzh: FaireProductEntity = {
  token: "p_ftn4v8dgzh",
  type: "product",
  name: "Fashionable Dachshund - Organic Jacquard Knit Baby Blanket",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/24e614789bead24b15b4c5195d323e72ae982ae6ff08022a27c065e98d94448b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9be030bbf3784c8cc92bb0bd12ec98c60682433d5a65d7d0cba1bde453bc1473.jpeg",
    "https://cdn.faire.com/fastly/be612ab9f312cfe78c1f0752a39c87e85300c737025abc5dc9ac0446047adf8c.jpeg",
  ],
  priceDollars: 26,
  description:
    "Organic Cotton Jacquard Baby Blanket – Fashionable Dachshund with Scarf Motif\n\nInspired by the calm rhythm of the ocean, this 100% organic cotton jacquard baby blanket features a beautifully textured knit with charming fashionable dachshund with scarf motifs—playful fish, crabs, and starfish woven into a timeless design.\n\nThe breathable jacquard construction offers a soft, lightweight, and cozy feel, making it perfect for all seasons. Gentle on delicate skin and free from harmful chemicals, it delivers natural comfort parents can trust.\n\nMade from sustainably grown organic cotton, this blanket supports better livelihoods for small grower farmers and reflects a commitment to responsible craftsmanship. Designed in the USA and ethically made by skilled artisans in India at a GOTS-certified facility, every piece is created with care and intention.\n\nIdeal for nursery decor, stroller rides, and quiet cuddle moments—this blanket brings a touch of the sea to everyday comfort.\n\nPure comfort, by Viverano.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:32.689Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
